import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["title", "description", "tooltip", "action", "media"];
import I18n from 'I18n';
import createSingleI18nProvider from 'I18n/init/providers/createSingleI18nProvider';
import getLangLocale from 'I18n/utils/getLangLocale';
import { ONBOARDING_BEACONS_I18N_LOADERS } from '../../__generated__/OnboardingBeaconsI18nLoaders';
const getOnboardingBeaconsI18nLoader = beaconsConfigId => {
  const loader = ONBOARDING_BEACONS_I18N_LOADERS[beaconsConfigId];
  return loader ? {
    load: loader
  } : null;
};
export const registerLangs = async langModules => {
  const i18nProvider = createSingleI18nProvider({
    language: getLangLocale()
  });
  await Promise.all(langModules.map(langModule => i18nProvider.register(langModule.default)));
};
export const loadBeaconsTranslations = async beaconsConfigId => {
  var _getOnboardingBeacons;
  const langModule = await ((_getOnboardingBeacons = getOnboardingBeaconsI18nLoader(beaconsConfigId)) === null || _getOnboardingBeacons === void 0 ? void 0 : _getOnboardingBeacons.load());
  return registerLangs([langModule]);
};

// Only exported for testing
export const checkIfAnyBeaconRequiresTranslations = beacons => {
  for (const beacon of beacons) {
    var _beacon$media;
    if (beacon.title === true || beacon.description === true || beacon.tooltip === true || beacon.action === true) {
      return true;
    }
    // check if image requires translations
    if (((_beacon$media = beacon.media) === null || _beacon$media === void 0 ? void 0 : _beacon$media.type) === 'image' && beacon.media.altText === true) {
      return true;
    }

    // check if action requires translations
    if (beacon.action) {
      var _beacon$action$button, _beacon$action$link;
      if (beacon.action.title === true || ((_beacon$action$button = beacon.action.button) === null || _beacon$action$button === void 0 ? void 0 : _beacon$action$button.text) === true || ((_beacon$action$link = beacon.action.link) === null || _beacon$action$link === void 0 ? void 0 : _beacon$action$link.text) === true) {
        return true;
      }
    }
  }
  return false;
};
export const populateBeaconsWithCopy = beaconsConfig => {
  const {
    beaconsConfigId,
    beacons,
    onBeaconsDismiss,
    disabled
  } = beaconsConfig;
  const requiresTranslations = checkIfAnyBeaconRequiresTranslations(beacons);
  if (!requiresTranslations) {
    return beaconsConfig;
  }

  // Ensures the i18n namespace exists and throws an early error, to prevent error reporting to dependent apps
  if (
  // @ts-ignore I18n.lookup is not typed
  !I18n.lookup(`onboarding-beacons-${beaconsConfigId}`)) {
    throw new Error(`Missing translation. Please import lyaml containing namespace: "onboarding-beacons-${beaconsConfigId}".`);
  }
  const internalBeaconsRepresentation = [];
  for (const beacon of beacons) {
    const {
        title,
        description,
        tooltip,
        action,
        media
      } = beacon,
      untransformedFields = _objectWithoutPropertiesLoose(beacon, _excluded);
    const internalTitle = title === true ? I18n.text(`onboarding-beacons-${beaconsConfigId}.${beacon.beaconId}.title`) : title;
    const internalDescription = description === true ? I18n.text(`onboarding-beacons-${beaconsConfigId}.${beacon.beaconId}.description`) : description;
    const internalTooltip = Object.assign({}, tooltip === true ? {} : tooltip, {
      text: tooltip === true ? I18n.text(`onboarding-beacons-${beaconsConfigId}.${beacon.beaconId}.tooltipText`) : tooltip === null || tooltip === void 0 ? void 0 : tooltip.text
    });
    const internalMedia = media.type === 'image' ? Object.assign({}, media, {
      altText: media.type === 'image' && media.altText === true ? I18n.text(`onboarding-beacons-${beaconsConfigId}.${beacon.beaconId}.altText`) : undefined
    }) : media;
    const internalBeaconConfig = Object.assign({}, untransformedFields, {
      title: internalTitle,
      description: internalDescription,
      tooltip: internalTooltip,
      media: internalMedia
    });
    if (action) {
      var _internalAction$butto, _internalAction$link;
      const internalAction = action === true ? {} : action;
      internalBeaconConfig.action = Object.assign({}, internalAction, {
        title: internalAction.title === true ? I18n.text(`onboarding-beacons-${beaconsConfigId}.${beacon.beaconId}.actionTitle`) : internalAction.title,
        button: ((_internalAction$butto = internalAction.button) === null || _internalAction$butto === void 0 ? void 0 : _internalAction$butto.text) === true ? Object.assign({}, internalAction.button, {
          text: I18n.text(`onboarding-beacons-${beaconsConfigId}.${beacon.beaconId}.actionButtonText`)
        }) : internalAction.button,
        link: ((_internalAction$link = internalAction.link) === null || _internalAction$link === void 0 ? void 0 : _internalAction$link.text) === true ? Object.assign({}, internalAction.link, {
          text: I18n.text(`onboarding-beacons-${beaconsConfigId}.${beacon.beaconId}.actionLinkText`)
        }) : internalAction.link
      });
    }
    internalBeaconsRepresentation.push(internalBeaconConfig);
  }
  return {
    beaconsConfigId,
    beacons: internalBeaconsRepresentation,
    onBeaconsDismiss,
    disabled
  };
};